import { Label } from '@heroui/react';
import { cn } from '@/lib/cn';

type FieldLabelProps = React.ComponentProps<typeof Label>;

/**
 * Лейбл поля формы: компактнее дефолтного `text-sm font-medium`
 * (12px, muted — в стилистике подписей InfoRow). На Surface Card.
 */
export function FieldLabel({ className, ...props }: FieldLabelProps) {
  return <Label {...props} className={cn('text-xs font-medium text-muted', className)} />;
}
